// Kleines Hilfs-Component für Status-Anzeigen (Ereignisse, Rechnungen, Mandanten).
//
// Der CSS-Klassenname muss URL-/CSS-tauglich sein, daher mappen wir
// "in Arbeit" auf "in-arbeit".
export default function StatusBadge({ status }) {
    const cls = 'status status--' + String(status).replace(/\s+/g, '-');
    return <span className={cls}>{status}</span>;
}
